import React, { useEffect, useState } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Catalog from './pages/catalog-page';
import RegisterPage from './pages/register-page';
import LoginPage from './pages/login-page';
import NotFound from './pages/NotFoundPage';
import Layout from './components/layouts/layout';
import NoHeaderLayout from './components/layouts/no-header-layout';
import ForgotPass from './pages/forgot-pass-page';
import Moodboard from './pages/moodboard-page';
import Product from './pages/product-page';
import UserProfilePage from './pages/user-profile-page';
import CartPage from './pages/cart-page';
import CheckoutPage from './pages/checkout-page';
import ThankYouPage from './pages/thank-you-page';
import ProtectedRoute from './routes/protected-route';
import { AuthProvider } from './context/authContext';
import ThankYouLayout from './components/layouts/thank-you-layout';
import ContactPage from './pages/contact-page';
import AppointmentPage from './pages/appointment-page';
import { ProductsContext } from './context/productsContext';
import SingleMoodboard from './pages/single-moodboard-page';
import JoinUsPage from './pages/join-us-page';
import BrandsPage from './pages/brands-page';
import BrandPage from './pages/brand-page';

function App() {
  const [context, setContext] = useState([]);
  const location = window.location;
  const googleProfileUser = localStorage.getItem('googleProfile');
  const authUser = localStorage.getItem('auth-user');
  const closeOverlay = (e) => {
    const overlay = document.querySelector('.overlay-out');
    const createPopup = document.querySelector('.create-popup');
    if(overlay && createPopup) {
      if(e.target.className === 'overlay-out') {
        //overlay.remove();
        //createPopup.sty();
      }
    }
  }
  
  useEffect(() => {
    //document.addEventListener('click', closeOverlay);
    let rootElement = document.getElementById('root');
    if(rootElement) {
      if(window.innerWidth < 768) {
        rootElement.classList.add('mobile-app');
        rootElement.classList.remove('desktop-app');
      }
      else {
        rootElement.classList.add('desktop-app');
        rootElement.classList.remove('mobile-app');
      }
    }
    // return () => {
    //     document.removeEventListener('click', closeOverlay);
    //   }
  }, []);

  return (
    <div className="App">
      <AuthProvider>
        <ProductsContext.Provider value={[context, setContext]}>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<NoHeaderLayout />}>
                <Route path="register" element={<RegisterPage />} />
                <Route path="join" element={<JoinUsPage />} />
                <Route path="login" element={<LoginPage />} />
                <Route path="forgotpass" element={<ForgotPass />} />
                <Route path="checkout" element={<CheckoutPage />} />
                <Route path="contact" element={
                      <ProtectedRoute>
                      <ContactPage />
                    </ProtectedRoute>
                  } />
                <Route path="appointment" element={
                    <ProtectedRoute>
                    <AppointmentPage />
                    </ProtectedRoute>
                  } />
              </Route>
              <Route path="/" element={<ThankYouLayout />}>
                <Route path="thank-you" element={
                  <ProtectedRoute>
                      <ThankYouPage />
                    </ProtectedRoute>
                } />
              </Route>   

              {!authUser && !googleProfileUser ? (
                <Route index element={
                    <JoinUsPage />
                } />
              ) : (
                <Route path="/" element={<Layout />}>
                  <Route index element={
                    <ProtectedRoute>
                      <Catalog />
                    </ProtectedRoute>
                  } />
                </Route>
              )}

              <Route path="/" element={<Layout />}>
                <Route path="catalog" element={
                  <ProtectedRoute>
                    <Catalog />
                  </ProtectedRoute>
                } />
                <Route path="brands" element={
                  <ProtectedRoute>
                    <BrandsPage />
                  </ProtectedRoute>
                } />
                <Route path="me" element={
                  <ProtectedRoute>
                    <UserProfilePage />
                  </ProtectedRoute>
                } />
                <Route path="moodboard" element={
                  <ProtectedRoute>
                    <Moodboard />
                  </ProtectedRoute>
                } />
                <Route path="moodboard/:id" element={
                  <ProtectedRoute>
                    <SingleMoodboard />
                  </ProtectedRoute>
                } />
                <Route path="cart" element={
                  <ProtectedRoute>
                    <CartPage />
                  </ProtectedRoute>
                } />
                <Route path="product/:id" element={
                  <ProtectedRoute>
                    <Product />
                  </ProtectedRoute>
                } />
                <Route path="brands/:brandName" element={
                  <ProtectedRoute>
                    <BrandPage />
                  </ProtectedRoute>
                } />
                <Route path="*" element={<NotFound />} />
              </Route>
            </Routes>
          </BrowserRouter>
        </ProductsContext.Provider>
    </AuthProvider>
    </div>
  );
}

export default App;
